import { useQuery } from "@tanstack/react-query";
import { getAllPackages } from "../../api/apiPackages";

const useGetPackages = (page = 1, perPage = 15, filters = {}) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["packages", page, perPage, filters],
        queryFn: () => getAllPackages(page, perPage, filters),
    });

    return {
        packages: data?.data || {},
        meta: data?.data?.meta || {},
        error,
        isLoading,
        refetch,
    };
};

export default useGetPackages;
